import { toast } from "react-toastify";
import { Axios } from "../Axios";

const updateUser = async (formData) => {
  try {
    const updatedUserData = {
      ...formData,
      birthday:
        Array.isArray(formData.birthday) && formData.birthday.length > 0
          ? new Date(formData.birthday[0]).toISOString()
          : typeof formData.birthday === "object" && formData.birthday?.toDate?.()
            ? formData.birthday.toDate().toISOString()
            : typeof formData.birthday === "string"
              ? new Date(formData.birthday).toISOString()
              : "",
    };

    const response = await Axios.put("/users/registerUser", updatedUserData);
    toast.success("اطلاعات با موفقیت ثبت شد");
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message || "خطا در ثبت اطلاعات");
    throw error;
  }
};

export default updateUser;
